/*
* Copyright (C) Regione Lombardia
*/
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PagesGestioneProgettoCreaProgettoComponent } from './crea-progetto/crea-progetto.component';
import { PagesGestioneProgettoDettaglioProgettoComponent } from './dettaglio-progetto/dettaglio-progetto.component';
import { GestioneProgettoDettaglioProgettoResolver } from './dettaglio-progetto/dettaglio-progetto.resolver';
import { PagesGestioneProgettoModificaProgettoComponent } from './modifica-progetto/modifica-progetto.component';
import { GestioneProgettoModificaProgettoResolver } from './modifica-progetto/modifica-progetto.resolver';
import { PagesGestioneProgettoRicercaProgettoComponent } from './ricerca-progetto/ricerca-progetto.component';

@NgModule({
    imports: [RouterModule.forChild([
        { path: 'ricerca', component: PagesGestioneProgettoRicercaProgettoComponent },
        {
            path: 'dettaglio/:idProgetto', 
            component: PagesGestioneProgettoDettaglioProgettoComponent,
            resolve: { additionalInformation: GestioneProgettoDettaglioProgettoResolver },
        },
        {
            path: 'dettaglio/:idProgetto/modifica', 
            component: PagesGestioneProgettoModificaProgettoComponent,
            resolve: { additionalInformation: GestioneProgettoModificaProgettoResolver },
        },
        { path: 'crea', component: PagesGestioneProgettoCreaProgettoComponent },
        { path: '**', redirectTo: 'ricerca' },
    ])],
    exports: [
        RouterModule,
    ]
})
export class PagesGestioneProgettoRoutingModule { }
